import { z } from 'zod';

export const offeringSessionRuleSetSchema = z.object({
  startDate: z.string().min(1, { message: 'Required' }),
  endDate: z.string().min(1, { message: 'Required' }),
  offeringSessionRules: z
    .array(
      z.object({
        dayOfWeek: z.number().int().min(0).max(6),
        time: z.string()
      })
    )
    .min(1, { message: 'At least one time slot is required' })
});
